import { createFileRoute } from '@tanstack/react-router'
import PostsList from '@/components/PostsList'
import { useUi } from '@/lib/i18n/ui'

export const Route = createFileRoute('/articles/')({
  // "Articles" is Ken's preferred label (states think of "guides" as printed
  // booklets). Same data feed as /posts; we expose both URLs.
  component: ArticlesIndex,
})

function ArticlesIndex() {
  const t = useUi()
  return <PostsList title={t.articlesTitle} intro={t.articlesIntro} />
}
